import { createApp, ref, onMounted } from 'vue'

const app = createApp({
  setup() {
    const isShowAttention = ref(false)
    onMounted(() => {
      if (sessionStorage.getItem('attentionShow') === 'value') {
        isShowAttention.value = false
      } else {
        isShowAttention.value = true
      }
    })
    const closeAttention = () => {
      isShowAttention.value = false
      sessionStorage.setItem('attentionShow', 'value')
    }
    return { isShowAttention, closeAttention }
  }
})
if (document.querySelector('#announce')) {
  app.mount('#announce')
}
